import React, { useState, useEffect } from "react"

import toastHandler from "toastHandler"
import { getAuditoriaLogs } from "api"

import Layout from "components/Layout"
import AuditoriaLogs from "./AuditoriaLogs"

const Index = ({ permissionBy }) => {
  const [auditoriaLogs, setAuditoriaLogs] = useState([])
  const { setError } = toastHandler()

  useEffect(() => {
    getAuditoriaLogs().then(setAuditoriaLogs).catch(setError)
  }, [])

  const components = [
    { component: <AuditoriaLogs {...{ auditoriaLogs, setAuditoriaLogs }} /> },
  ]

  return (
    <Layout
      components={components}
      title="Auditoría Logs"
      permissionBy={permissionBy}
    />
  )
}

export default Index
